import {
    $, addFilter, addAction, INIT,
} from '@situation/setdesign.util';

addAction(INIT, () => {
    const $tabSection = $('.content-section--talent-tabs');
    if (!$tabSection.length) {
        return;
    }

    addFilter('css-vars/register', (styles) => ({
        ...styles,
        'tab-section-height': () => `${$tabSection.outerHeight(true)}px`,
    }));
});
